import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { BarTender_ModuleContextService } from './BarTender.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class BarTender_azure_blob_storage_navigation_grid_ComponentContextService {
  private readonly moduleContext: BarTender_ModuleContextService;

  constructor(moduleContext: BarTender_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'azure_blob_storage_navigation_grid',
      type: ComponentType.grid
    }
  }
}